<template>
  <div class="bg-slate-50 border-b border-slate-200">
    <div class="max-w-7xl mx-auto">
      <div class="flex items-center justify-center gap-3 py-3">
        <!-- Sol İkon -->
        <div class="hidden sm:block">
          <div class="flex items-center justify-center w-8 h-8 bg-orange-50 rounded-lg">
            <UIcon name="i-heroicons-truck" class="w-4 h-4 text-orange-500" />
          </div>
        </div>

        <!-- Mesaj -->
        <div class="flex items-center gap-2">
          <p class="text-sm sm:text-base font-medium">
            <span class="text-slate-700">100 TL ve Üzeri Alışverişlerde</span>
            <span class="text-orange-500 font-semibold ml-1.5">Kargo Bedava!</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Removed pattern-lines as we're using gradients for decoration */
</style>
